import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import './i18n/config';
import './scss/index.scss';
import { store } from './store';

/**
 * App Client Side Render (CSR).
 *
 * Use ReactDOM.hydrate for Server Side Render (SSR).
 */
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
